import { getTripTypesRequest } from '../requests';
import { throttle } from '@/core';

async function getTripTypes({ state, commit }) {
	try {
		if (state.tripTypes.length === 0) {
			await fetchTripTypes();
		} else {
			await throttle(fetchTripTypes, 'fetchTripTypes', 60 * 1000);
		}
	} catch (err) {
		console.log(`Get tripTypes failed: ${err}`);
	}

	async function fetchTripTypes() {
		let response = await getTripTypesRequest();
		commit('setTripTypes', response);
	}
}

export default {
	getTripTypes
};